let refreshTimerId: ReturnType<typeof setTimeout> | null = null;
let warningTimerId: ReturnType<typeof setTimeout> | null = null;
let warningCountdownId: ReturnType<typeof setTimeout> | null = null;

export function getRefreshTimerId(): ReturnType<typeof setTimeout> | null {
  return refreshTimerId;
}

export function setRefreshTimerId(id: ReturnType<typeof setTimeout> | null): void {
  refreshTimerId = id;
}

export function getWarningTimerId(): ReturnType<typeof setTimeout> | null {
  return warningTimerId;
}

export function setWarningTimerId(id: ReturnType<typeof setTimeout> | null): void {
  warningTimerId = id;
}

export function getWarningCountdownId(): ReturnType<typeof setTimeout> | null {
  return warningCountdownId;
}

export function setWarningCountdownId(id: ReturnType<typeof setTimeout> | null): void {
  warningCountdownId = id;
}

export function clearAllSessionTimers(): void {
  if (refreshTimerId) {
    clearTimeout(refreshTimerId);
    refreshTimerId = null;
  }
  if (warningTimerId) {
    clearTimeout(warningTimerId);
    warningTimerId = null;
  }
  if (warningCountdownId) {
    clearTimeout(warningCountdownId);
    warningCountdownId = null;
  }
}
